/**
 * @component IntakeItemRedirect
 * @description Legacy-route shim: the pre-console intake detail and edit
 * pages lived at `/intake/:itemId` and `/intake/:itemId/edit`. Both now land
 * on the board with that item's detail panel open, through the same URL
 * overlay param a row click writes, so a bookmark and a click produce one
 * URL. A missing id falls through to the bare board.
 */

import { Navigate, useParams } from 'react-router-dom'

export default function IntakeItemRedirect() {
  const { itemId } = useParams<{ itemId: string }>()
  const target = itemId
    ? `/intake?item=${encodeURIComponent(itemId)}`
    : '/intake'
  return <Navigate to={target} replace />
}
